export default "__VITE_ASSET__BRSciHBk__"